/* Bilingual copy: NL (default) + EN. Facts come from the owner's own words; no invented claims. */

export const translations = {
  nl: {
    brand: {
      name: "PIERRE",
      tag: "Strength & Technique",
    },
    nav: {
      home: "Home",
      about: "Over Andre",
      coaching: "Coaching",
      contact: "Contact",
      intakeCta: "Vraag een intake aan",
      menuOpen: "Menu openen",
      menuClose: "Menu sluiten",
    },
    hero: {
      badge: "1-op-1 privé krachttraining • Creatieve & executive focus",
      titleTop: "MIND, SPIRIT",
      titleBottom: "& SPIEREN ALS ÉÉN",
      sub: "Techniek-gerichte krachtcoaching voor vrouwen en creatieve performers — zonder drukke-sportschool-ego's.",
      ctaPrimary: "Plan een kennismakingsgesprek",
      ctaSecondary: "Maak kennis met coach Andre",
      cardEmailLabel: "Direct bereikbaar",
      cardFormatLabel: "Trainingsvorm",
      cardFormatValue: "Privé 1 op 1 & online coaching, overal",
      cardSafetyLabel: "Veilige discipline",
      cardSafetyValue: "Geen ego-lifting. Biomechanica & neuromusculaire precisie.",
    },
    marquee: [
      "Geen ego-lifting",
      "1-op-1 persoonlijke aandacht",
      "Sing & Songwriters • Schrijvers • Producers • Designers",
      "Techniek en veiligheid eerst",
      "Geen drukke sportschoolsfeer",
    ],
    about: {
      eyebrow: "Coachingsfilosofie",
      title: "Pure Techniek & Alignment.",
      quote:
        "Ik ben niet je typische stereotype trainer. Ik begrijp vrouwen en creatievelingen als geen ander: je houding, je zenuwstelsel en de fysieke eisen van je vak. Geen ego-lifting, maar het vakmanschap van hoe je traint en hoe je mind, spirit en spieren als één geheel met elkaar verbindt.",
      portraitCaption: "Coach Andre • Head Coach",
      fact1Value: "ALLEEN 1-OP-1",
      fact1Label: "Volledig gefocuste privésessies",
      fact2Value: "BIOMECHANICA",
      fact2Label: "Veilige, structurele opbouw",
      moreLink: "Lees meer over Andre",
    },
    audience: {
      eyebrow: "Omgevingen op maat",
      title: "Gebouwd voor specifieke eisen",
      cards: [
        {
          tag: "01 • Creatieven",
          title: "Sing & songwriters, schrijvers & artiesten",
          body: "Laat studiovermoeidheid los, breng adem en core-stabiliteit op één lijn en behoud vitale vocale én fysieke stamina.",
          caption: "Houding & adem: spanning loslaten",
        },
        {
          tag: "02 • Kracht voor vrouwen",
          title: "Zelfvertrouwen & power",
          body: "Veilige progressieve overload zonder hypermannelijke intimidatie. Leer onberispelijke barbell- en kettlebelltechniek.",
          caption: "Barbelltechniek & gewrichtsveiligheid",
        },
        {
          tag: "03 • Executives",
          title: "Leiders & producers",
          body: "Uiterst efficiënte fysieke conditioning die mentale scherpte versterkt en in een volle agenda past.",
          caption: "High-output stamina training",
        },
      ],
    },
    gallery: {
      eyebrow: "Visueel journaal",
      title: "Techniek in de praktijk",
      handle: "Instagram • @PierreCoaching",
      captions: [
        "Grip & barbell setup",
        "Hip-hinge alignment",
        "Thoracale mobiliteit",
        "1-op-1 review",
      ],
      proofEyebrow: "Klantfeedback",
      proofTitle: "Reflecties van leden",
      proofBody:
        "Geverifieerde verhalen en voortgangsnotities van onze creatieve en executive leden worden hier gepubliceerd.",
    },
    intake: {
      eyebrow: "Directe aanmelding",
      title: "Vraag je kennismakingsintake aan",
      sub: "Begin met een gesprek van 30 minuten met Andre om je bewegingsbasis en doelen vast te stellen.",
      nameLabel: "Je naam",
      namePlaceholder: "Maya Lin",
      emailLabel: "E-mailadres",
      emailPlaceholder: "maya@studio.com",
      focusLabel: "Je focus / discipline",
      formatLabel: "Trainingsvorm",
      notesLabel: "Doelen & eerdere ervaring",
      notesPlaceholder: "Vertel Andre over je fysieke eisen en verwachtingen...",
      focusOptions: [
        "Creatief (sing & songwriter / schrijver / designer)",
        "Executive / manager / leider",
        "Veilige krachttraining voor vrouwen",
        "Algemeen bewegingsmeesterschap",
      ],
      formatOptions: [
        "Privéstudio op locatie (1-op-1)",
        "Online coaching (overal)",
      ],
      submit: "Verstuur intake-aanvraag",
      submitting: "Versturen...",
      successTitle: "Aanvraag ontvangen",
      successBody: "Je intake-aanvraag is verstuurd. Je hoort snel van Andre.",
      errorTitle: "Versturen mislukt",
      errorBody: "Er ging iets mis. Probeer het opnieuw of mail direct.",
      preferEmail: "Liever direct mailen?",
    },
    footer: {
      led: "Onder leiding van coach Andre • Tweetalig NL / EN",
      rights: "© Pierre Coaching. Alle rechten voorbehouden.",
      contactLabel: "Contact",
    },
    aboutPage: {
      seoTitle: "Over Andre — Pierre Strength & Technique Coaching",
      seoDesc:
        "Maak kennis met coach Andre: geen stereotype trainer, maar techniek-eerst krachtcoaching die mind, spirit en spieren als één geheel verbindt.",
      eyebrow: "Over Andre",
      title: "De Coach Achter Pierre Strength",
      lead:
        "Andre is geen stereotype trainer. Hij begrijpt vrouwen en mensen uit het creatieve veld — sing & songwriters, producers, acteurs, schrijvers en designers — en weet precies welke fysieke eisen hun vak stelt.",
      body1:
        "Zijn aanpak draait niet om ego-lifting, maar om vakmanschap: hoe je tilt, hoe je traint en hoe je mind, spirit en spieren als één geheel met elkaar verbindt. Techniek staat altijd voorop, zodat kracht veilig en duurzaam wordt opgebouwd.",
      body2:
        "Elke sessie is 1-op-1. Geen drukke sportschool, geen afleiding — alleen volledige aandacht voor jouw beweging, houding en progressie. Ook professionals, managers en natuurlijke leiders vinden hier een rustige, efficiënte trainingsomgeving.",
      principlesEyebrow: "Waar Andre voor staat",
      principlesTitle: "Principes van zijn aanpak",
      principles: [
        {
          title: "Techniek vóór belasting",
          body: "Elke herhaling wordt eerst correct. Pas dan komt er gewicht bij. Zo blijft progressie veilig.",
        },
        {
          title: "Mind–muscle connectie",
          body: "Je traint niet alleen spieren, maar ook aandacht en adem. Mind, spirit en spieren als één geheel.",
        },
        {
          title: "Privé, gefocuste ruimte",
          body: "1-op-1 aandacht zonder de drukte en het ego van een reguliere sportschool.",
        },
        {
          title: "Veiligheid als discipline",
          body: "Biomechanica en neuromusculaire precisie vormen de basis van elke training.",
        },
      ],
      ctaTitle: "Trainen zonder ego, met volledige aandacht",
      ctaBody: "Plan een kennismakingsgesprek en ervaar hoe techniek-eerst coaching voelt.",
      ctaButton: "Vraag een intake aan",
    },
    coachingPage: {
      seoTitle: "Strength & Technique Coaching — Pierre Coaching",
      seoDesc:
        "1-op-1 strength & technique coaching voor vrouwen, creatieven en professionals. Privéstudio en online. Techniek eerst, geen ego-lifting.",
      eyebrow: "Strength & Technique",
      title: "Coaching gebouwd op vakmanschap, niet op ego",
      lead:
        "Krachttraining bij Pierre begint bij techniek. Je leert hoe je tilt, hoe je traint en hoe je je lichaam als één geheel gebruikt — veilig, efficiënt en passend bij jouw vak en leven.",
      pillarsEyebrow: "De methode",
      pillarsTitle: "Vier pijlers van elke sessie",
      pillars: [
        {
          title: "Assessment eerst",
          body: "De intake brengt je bewegingsbasis en doelen in kaart. Daar wordt je traject op gebouwd.",
        },
        {
          title: "Techniekblokken",
          body: "Barbell-, kettlebell- en bodyweight-mechanica worden stap voor stap aangeleerd en verfijnd.",
        },
        {
          title: "Veilige progressieve overload",
          body: "Belasting groeit pas als de techniek het toelaat. Duurzame kracht zonder blessurerisico.",
        },
        {
          title: "Adem, houding & focus",
          body: "Essentieel voor zangers, performers en iedereen die zijn lichaam professioneel gebruikt.",
        },
      ],
      tracksEyebrow: "Voor wie",
      tracksTitle: "Tracks op maat",
      tracks: [
        {
          title: "Creatieven & performers",
          body: "Sing & songwriters, producers, acteurs, schrijvers en designers: los studiovermoeidheid los en bouw vocale en fysieke stamina op.",
        },
        {
          title: "Kracht voor vrouwen",
          body: "Veilige progressieve overload zonder hypermannelijke intimidatie. Techniek en zelfvertrouwen eerst.",
        },
        {
          title: "Professionals & leiders",
          body: "Efficiënte conditioning voor managers, ondernemers en natuurlijke leiders met een volle agenda.",
        },
      ],
      formatsEyebrow: "Trainingsvormen",
      formatsTitle: "Privé sessie of online",
      formats: [
        {
          title: "Privé sessie 1 op 1",
          body: "Persoonlijke sessies 1 op 1 in de gym of rustige omgeving. Volledige aandacht en focus op Body, Mind, Spirit and Muscles.",
        },
        {
          title: "Online coaching (overal)",
          body: "Waar je ook bent: techniekcoaching op afstand met dezelfde persoonlijke aandacht.",
        },
      ],
      ctaTitle: "Klaar om techniek-eerst te trainen?",
      ctaBody: "Vraag een kennismakingsintake aan en bespreek je doelen met Andre.",
      ctaButton: "Vraag een intake aan",
    },
    contactPage: {
      seoTitle: "Contact & Intake — Pierre Strength & Technique Coaching",
      seoDesc:
        "Vraag een kennismakingsintake aan bij Pierre Strength & Technique Coaching of mail coach Andre direct.",
      eyebrow: "Contact & intake",
      title: "Begin het gesprek",
      lead:
        "Vraag een kennismakingsgesprek van 30 minuten aan om je bewegingsbasis en doelen te bespreken — in de privéstudio of online.",
      emailCardLabel: "Direct mailen",
      expectTitle: "Wat je kunt verwachten",
      expect: [
        "Een gesprek van 30 minuten met Andre, persoonlijk of online",
        "Een inschatting van je bewegingsbasis en doelen",
        "Een eerlijk advies over het passende traject",
      ],
    },
    homeSeo: {
      title: "Pierre Strength & Technique Coaching — 1-op-1 krachtcoaching NL/EN",
      desc: "Techniek-eerst 1-op-1 krachtcoaching voor vrouwen, creatieven en professionals. Privéstudio en online. Vraag een kennismakingsintake aan.",
    },
    notFound: {
      title: "Pagina niet gevonden",
      body: "Deze pagina bestaat niet. Ga terug naar de homepagina.",
      cta: "Naar home",
    },
    chat: {
      title: "Pierre Assistent",
      subtitle: "Vraag over coaching, intake of training",
      placeholder: "Typ je vraag...",
      send: "Verstuur",
      chips: {
        assistant: "Vraag over coaching",
        intake: "Help mijn doelen formuleren",
        tips: "Trainingsadvies",
      },
      error: "Er ging iets mis. Probeer het opnieuw.",
      limitReached:
        "Je hebt het maximum voor deze sessie bereikt. Mail Andre direct via Aondaatje.1@hotmail.com.",
      openLabel: "Chat openen",
      closeLabel: "Chat sluiten",
    },
    admin: {
      title: "Media Beheer",
      pinLabel: "Admin PIN",
      pinButton: "Inloggen",
      wrongPin: "Onjuiste PIN",
      uploadTitle: "Foto uploaden",
      slotLabel: "Plek op de site",
      slots: { gallery: "Galerij", logo: "Logo", portrait: "Portret van Andre" },
      altLabel: "Beschrijving (alt-tekst)",
      chooseFile: "Kies een afbeelding",
      uploadButton: "Uploaden",
      uploading: "Uploaden...",
      uploadSuccess: "Foto geüpload en zichtbaar op de site.",
      uploadError: "Uploaden mislukt. Alleen JPG/PNG/WebP, max 8 MB.",
      listTitle: "Huidige foto's",
      deleteButton: "Verwijderen",
      deleteSuccess: "Foto verwijderd.",
      empty: "Nog geen uploads — de site toont de standaardbeelden.",
    },
    packages: {
      eyebrow: "Trainingspakketten",
      title: "Boek je pakket",
      sub: "Betaal veilig met PayPal. Na betaling neemt Andre contact op om de sessies in te plannen.",
      durationNote: "8 weken | 8 trainingen",
      comingSoon: "Online betaling volgt binnenkort. Mail Andre om dit pakket te reserveren.",
      mailCta: "Reserveer via e-mail",
      paySuccessTitle: "Betaling ontvangen",
      paySuccessBody: "Je pakket is betaald. Andre neemt contact met je op om te plannen.",
      payErrorTitle: "Betaling mislukt",
      payErrorBody: "Er ging iets mis bij PayPal. Probeer opnieuw of mail Andre.",
      items: [
        {
          id: "spieropbouw",
          name: "Spieropbouw",
          tagline: "Sterker. Groter. Techniek.",
          price: "449",
          features: [
            "8 persoonlijke trainingen (1x per week, 8 weken)",
            "Persoonlijk trainingsplan",
            "Techniek- en uitvoeringcoaching",
            "Voortgangscontrole",
            "Basis voedingsrichtlijnen voor spieropbouw",
            "Korte evaluatie",
          ],
        },
        {
          id: "spieropbouw-afvallen",
          name: "Spieropbouw + Afvallen",
          tagline: "Een sterker en fitter lichaam.",
          price: "499",
          features: [
            "8 persoonlijke trainingen (1x per week, 8 weken)",
            "Persoonlijk trainingsplan",
            "Techniekcoaching",
            "Voortgangsmetingen",
            "Voedingsbegeleiding gericht op lichaamssamenstelling",
            "Wekelijkse korte check-in",
            "Aanpassing trainingsbelasting",
          ],
        },
        {
          id: "afvallen",
          name: "Afvallen",
          tagline: "Lichter. Sterker. Meer energie.",
          price: "449",
          features: [
            "8 persoonlijke trainingen (1x per week, 8 weken)",
            "Persoonlijk trainingsplan",
            "Techniekcoaching",
            "Voortgangsmetingen",
            "Algemene voedingsbegeleiding",
            "Wekelijkse korte check-in",
            "Aanpassing van het programma",
          ],
        },
      ],
    },
  },

  en: {
    brand: {
      name: "PIERRE",
      tag: "Strength & Technique",
    },
    nav: {
      home: "Home",
      about: "About Andre",
      coaching: "Coaching",
      contact: "Contact",
      intakeCta: "Request Intake",
      menuOpen: "Open menu",
      menuClose: "Close menu",
    },
    hero: {
      badge: "1-on-1 Private Strength • Creative & Executive Focus",
      titleTop: "MIND, SPIRIT",
      titleBottom: "& MUSCLES AS ONE",
      sub: "Technique-first strength coaching engineered for women and creative performers without crowded-gym ego.",
      ctaPrimary: "Book Introductory Meeting",
      ctaSecondary: "Meet Coach Andre",
      cardEmailLabel: "Direct Reach",
      cardFormatLabel: "Service Format",
      cardFormatValue: "Private 1-on-1 & Global Online Coaching",
      cardSafetyLabel: "Safe Discipline",
      cardSafetyValue: "Zero ego-lifting. Biomechanics & neuromuscular precision.",
    },
    marquee: [
      "No Ego Lifting",
      "1-on-1 Private Attention",
      "Sing & Songwriters • Writers • Producers • Designers",
      "Technique-First Safety",
      "No Crowded Gym Atmosphere",
    ],
    about: {
      eyebrow: "Coaching Philosophy",
      title: "Pure Technique & Alignment.",
      quote:
        "I am not your typical stereotype trainer. I deeply understand women and creatives: your posture, nervous system, and physical demands. No ego lifting, but true mastery of mind, spirit, and muscle integration.",
      portraitCaption: "Coach Andre • Head Coach",
      fact1Value: "1-ON-1 ONLY",
      fact1Label: "Focused private session space",
      fact2Value: "BIOMECHANICS",
      fact2Label: "Safe structural progression",
      moreLink: "Read more about Andre",
    },
    audience: {
      eyebrow: "Tailored Environments",
      title: "Engineered for Specific Demands",
      cards: [
        {
          tag: "01 • Creatives",
          title: "Sing & Songwriters, Writers & Artists",
          body: "Release studio fatigue, align breath and core stability, and maintain vital vocal and physical stamina.",
          caption: "Posture & breath tension release",
        },
        {
          tag: "02 • Women Strength",
          title: "Confidence & Power",
          body: "Safe progressive overload without hyper-masculine intimidation. Learn flawless barbell and kettlebell mechanics.",
          caption: "Barbell mechanics & joint safety",
        },
        {
          tag: "03 • Executives",
          title: "Leaders & Producers",
          body: "High-efficiency physical conditioning that sharpens mental clarity and handles demanding schedules.",
          caption: "High-output stamina training",
        },
      ],
    },
    gallery: {
      eyebrow: "Visual Journal",
      title: "Technique in Practice",
      handle: "Instagram • @PierreCoaching",
      captions: [
        "Grip & Barbell Setup",
        "Hip Hinge Alignment",
        "Thoracic Mobility",
        "1-on-1 Review",
      ],
      proofEyebrow: "Client Feedback",
      proofTitle: "Member Reflections",
      proofBody:
        "Verified stories and progress notes from our creative and executive intake members will be published here.",
    },
    intake: {
      eyebrow: "Direct Application",
      title: "Request Your Introductory Intake",
      sub: "Start with a 30-minute consultation with Andre to evaluate your movement baseline and goals.",
      nameLabel: "Your Name",
      namePlaceholder: "Maya Lin",
      emailLabel: "Email Address",
      emailPlaceholder: "maya@studio.com",
      focusLabel: "Your Focus / Discipline",
      formatLabel: "Training Format",
      notesLabel: "Goals & Past Experience",
      notesPlaceholder: "Tell Andre about your physical demands and expectations...",
      focusOptions: [
        "Creative (Sing & Songwriter / Writer / Designer)",
        "Executive / Manager / Leader",
        "Women's Safe Strength Track",
        "General Movement Mastery",
      ],
      formatOptions: [
        "In-Person Private Studio (1-on-1)",
        "Online Coaching (Anywhere)",
      ],
      submit: "Submit Intake Request",
      submitting: "Submitting...",
      successTitle: "Request received",
      successBody: "Your intake request has been sent. Andre will be in touch soon.",
      errorTitle: "Submission failed",
      errorBody: "Something went wrong. Please try again or email directly.",
      preferEmail: "Prefer email directly?",
    },
    footer: {
      led: "Led by Coach Andre • Bilingual NL / EN",
      rights: "© Pierre Coaching. All rights reserved.",
      contactLabel: "Contact",
    },
    aboutPage: {
      seoTitle: "About Andre — Pierre Strength & Technique Coaching",
      seoDesc:
        "Meet coach Andre: not a stereotype trainer, but technique-first strength coaching that connects mind, spirit and muscles as one whole.",
      eyebrow: "About Andre",
      title: "The Coach Behind Pierre Strength",
      lead:
        "Andre is no stereotype trainer. He deeply understands women and people from the creative field — sing & songwriters, producers, actors, writers and designers — and knows exactly what their craft demands of the body.",
      body1:
        "His approach is not about ego lifting, but about craft: how to lift, how to train, and how to connect mind, spirit and muscles as one whole unit. Technique always comes first, so strength is built safely and sustainably.",
      body2:
        "Every session is 1-on-1. No crowded gym, no distraction — just complete attention on your movement, posture and progression. Professionals, managers and natural leaders find the same calm, efficient training environment here.",
      principlesEyebrow: "What Andre Stands For",
      principlesTitle: "Principles of his approach",
      principles: [
        {
          title: "Technique Before Load",
          body: "Every rep is made correct first. Only then does weight increase. That keeps progress safe.",
        },
        {
          title: "Mind–Muscle Connection",
          body: "You train more than muscle: attention and breath. Mind, spirit and muscles as one whole.",
        },
        {
          title: "Private, Focused Space",
          body: "1-on-1 attention without the noise and ego of a regular gym floor.",
        },
        {
          title: "Safety as a Discipline",
          body: "Biomechanics and neuromuscular precision form the base of every session.",
        },
      ],
      ctaTitle: "Training without ego, with full attention",
      ctaBody: "Book an introductory meeting and feel what technique-first coaching is like.",
      ctaButton: "Request Intake",
    },
    coachingPage: {
      seoTitle: "Strength & Technique Coaching — Pierre Coaching",
      seoDesc:
        "1-on-1 strength & technique coaching for women, creatives and professionals. Private studio and online. Technique first, no ego lifting.",
      eyebrow: "Strength & Technique",
      title: "Coaching Built on Mastery, Not Ego",
      lead:
        "Strength training at Pierre starts with technique. You learn how to lift, how to train and how to use your body as one whole — safely, efficiently and fitted to your craft and your life.",
      pillarsEyebrow: "The Method",
      pillarsTitle: "Four pillars of every session",
      pillars: [
        {
          title: "Assessment First",
          body: "The intake maps your movement baseline and goals. Your trajectory is built on that.",
        },
        {
          title: "Technique Blocks",
          body: "Barbell, kettlebell and bodyweight mechanics are taught and refined step by step.",
        },
        {
          title: "Progressive Overload, Safely",
          body: "Load only grows when technique allows it. Sustainable strength without injury risk.",
        },
        {
          title: "Breath, Posture & Focus",
          body: "Essential for singers, performers and anyone who uses their body professionally.",
        },
      ],
      tracksEyebrow: "Who It's For",
      tracksTitle: "Tailored Tracks",
      tracks: [
        {
          title: "Creatives & Performers",
          body: "Sing & songwriters, producers, actors, writers and designers: release studio fatigue and build vocal and physical stamina.",
        },
        {
          title: "Women's Strength",
          body: "Safe progressive overload without hyper-masculine intimidation. Technique and confidence first.",
        },
        {
          title: "Professionals & Leaders",
          body: "Efficient conditioning for managers, business owners and natural leaders with demanding schedules.",
        },
      ],
      formatsEyebrow: "Training Formats",
      formatsTitle: "Private Session or Online",
      formats: [
        {
          title: "Private Session 1-on-1",
          body: "Personal 1-on-1 sessions in the gym or a calm environment. Full attention and focus on Body, Mind, Spirit and Muscles.",
        },
        {
          title: "Online Coaching (Anywhere)",
          body: "Wherever you are: remote technique coaching with the same personal attention.",
        },
      ],
      ctaTitle: "Ready to train technique-first?",
      ctaBody: "Request an introductory intake and discuss your goals with Andre.",
      ctaButton: "Request Intake",
    },
    contactPage: {
      seoTitle: "Contact & Intake — Pierre Strength & Technique Coaching",
      seoDesc:
        "Request an introductory intake at Pierre Strength & Technique Coaching or email coach Andre directly.",
      eyebrow: "Contact & Intake",
      title: "Start the Conversation",
      lead:
        "Request a 30-minute introductory meeting to discuss your movement baseline and goals — in the private studio or online.",
      emailCardLabel: "Email directly",
      expectTitle: "What to expect",
      expect: [
        "A 30-minute conversation with Andre, in person or online",
        "An assessment of your movement baseline and goals",
        "Honest advice on the right trajectory for you",
      ],
    },
    homeSeo: {
      title: "Pierre Strength & Technique Coaching — 1-on-1 Strength Coaching NL/EN",
      desc: "Technique-first 1-on-1 strength coaching for women, creatives and professionals. Private studio and online. Request an introductory intake.",
    },
    notFound: {
      title: "Page not found",
      body: "This page does not exist. Head back to the homepage.",
      cta: "Back to home",
    },
    chat: {
      title: "Pierre Assistant",
      subtitle: "Ask about coaching, intake or training",
      placeholder: "Type your question...",
      send: "Send",
      chips: {
        assistant: "Question about coaching",
        intake: "Help me shape my goals",
        tips: "Training advice",
      },
      error: "Something went wrong. Please try again.",
      limitReached:
        "You have reached this session's limit. Email Andre directly at Aondaatje.1@hotmail.com.",
      openLabel: "Open chat",
      closeLabel: "Close chat",
    },
    admin: {
      title: "Media Manager",
      pinLabel: "Admin PIN",
      pinButton: "Log in",
      wrongPin: "Incorrect PIN",
      uploadTitle: "Upload a photo",
      slotLabel: "Placement on the site",
      slots: { gallery: "Gallery", logo: "Logo", portrait: "Portrait of Andre" },
      altLabel: "Description (alt text)",
      chooseFile: "Choose an image",
      uploadButton: "Upload",
      uploading: "Uploading...",
      uploadSuccess: "Photo uploaded and live on the site.",
      uploadError: "Upload failed. JPG/PNG/WebP only, max 8 MB.",
      listTitle: "Current photos",
      deleteButton: "Delete",
      deleteSuccess: "Photo deleted.",
      empty: "No uploads yet — the site shows the default imagery.",
    },
    packages: {
      eyebrow: "Training Packages",
      title: "Book Your Package",
      sub: "Pay securely with PayPal. After payment Andre will contact you to schedule the sessions.",
      durationNote: "8 weeks | 8 sessions",
      comingSoon: "Online payment is coming soon. Email Andre to reserve this package.",
      mailCta: "Reserve via email",
      paySuccessTitle: "Payment received",
      paySuccessBody: "Your package is paid. Andre will contact you to schedule.",
      payErrorTitle: "Payment failed",
      payErrorBody: "Something went wrong with PayPal. Try again or email Andre.",
      items: [
        {
          id: "spieropbouw",
          name: "Muscle Building",
          tagline: "Stronger. Bigger. Technique.",
          price: "449",
          features: [
            "8 personal training sessions (1x per week, 8 weeks)",
            "Personal training plan",
            "Technique and execution coaching",
            "Progress tracking",
            "Basic nutrition guidelines for muscle building",
            "Short evaluation",
          ],
        },
        {
          id: "spieropbouw-afvallen",
          name: "Muscle Building + Fat Loss",
          tagline: "A stronger and fitter body.",
          price: "499",
          features: [
            "8 personal training sessions (1x per week, 8 weeks)",
            "Personal training plan",
            "Technique coaching",
            "Progress measurements",
            "Nutrition coaching focused on body composition",
            "Weekly short check-in",
            "Adjustment of training load",
          ],
        },
        {
          id: "afvallen",
          name: "Fat Loss",
          tagline: "Lighter. Stronger. More energy.",
          price: "449",
          features: [
            "8 personal training sessions (1x per week, 8 weeks)",
            "Personal training plan",
            "Technique coaching",
            "Progress measurements",
            "General nutrition coaching",
            "Weekly short check-in",
            "Adjustment of the program",
          ],
        },
      ],
    },
  },
};

export const CONTACT_EMAIL = "Aondaatje.1@hotmail.com";
